const withPhoto = photo => prevProject => ({
    ...prevProject,
    photo,
});

export default withPhoto;
